import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useAppSelector } from '../../app/hooks';
import { formatDays, formatDateAndMonth } from '../../common/timesheetFunction';
import { formatDateWithDateAndMonthName } from '../../common/timeLiveFunction';

const TimesheetTableHeaders = (props: any) => {
  const { timeEntriesList, startDateForPrint,endDateForPrint } = useAppSelector((state => state.timesheet));  
    const { showTimeOffInTimesheet, cultureInfoName } = useAppSelector((state) => state.globalState);
  let timeEntryHeader = [];
  let isHoliday = false;
  if (timeEntriesList[0]) {
    for (var i = 0; i < timeEntriesList[0].timeEntries.length; i++) {
      timeEntryHeader.push({
        "TimeEntryDate": timeEntriesList[0].timeEntries[i].TimeEntryDate,
        "Holiday": timeEntriesList[0].timeEntries[i].Holiday == null ? 0 : timeEntriesList[0].timeEntries[i].Holiday,
        "IsDayOff": timeEntriesList[0].timeEntries[i].isDayOff == null ? 0 : timeEntriesList[0].timeEntries[i].isDayOff,
        "HolidayName": timeEntriesList[0].timeEntries[i].holidayName == null ? '' : timeEntriesList[0].timeEntries[i].holidayName
      });
    }
  }
  isHoliday = timeEntryHeader.filter(x => x.Holiday == 1).length > 0 ? true : false;
const removeYear = (date: string) => {
    return date
        // year at start e.g. 2025/29/12 → 29/12
        .replace(/^\d{4}[\/\-\.]/, '')
        // year at end e.g. 29/12/2025 → 29/12
        .replace(/[\/\-\.]\d{4}$/, '')
        .trim();
};

  return (
    <>
      {timeEntryHeader.map((x: any, i: any) =>
        <th key={i} style={{ backgroundColor: x.IsDayOff == 1 ? '#172b4d1a' : '#f0f1f4', verticalAlign: isHoliday == true ? 'bottom' : 'middle', borderTopLeftRadius: i == 0 ? '5px' : '0px', borderBottomLeftRadius: i == 0 ? '5px' : '0px', borderLeftStyle: 'hidden' }}>
          {x.Holiday == 1 ?
            <span data-tooltip-id="my-tooltip-styles"
              data-tooltip-content={x.HolidayName}>
              <i className="bi bi-patch-exclamation fs-5 mx-1" style={{ color: '#172b4d' }}></i>
              <div>
                <span>
                  {formatDays(x.TimeEntryDate)}
                </span>
              </div>
              <span className='tsHeaderDateLabel'>{x.TimeEntryDate}</span>
              <Tooltip id="my-tooltip-styles" /></span> :
            <div>
              <div>
                <span>{formatDays(x.TimeEntryDate)}</span>
              </div>
              <span className="tsHeaderDateLabel">
                {removeYear(
                  formatDateWithDateAndMonthName(x.TimeEntryDate, cultureInfoName.toString())
                )}
               
              </span>
            </div>
          }
        </th>
      )}
    </>
  )
}
export default TimesheetTableHeaders